import Autoplay from "embla-carousel-autoplay";

import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

export function NeighborhoodFacts({ facts }: { facts: string[] }) {
  return (
    <div className="relative w-full space-y-2 max-w-xs">
      <h4 className="font-semibold">Fun Facts</h4>
      <Carousel
        opts={{
          align: "start",
          loop: true,
        }}
        plugins={[
          Autoplay({
            delay: 7000,
            stopOnInteraction: false,
          }),
        ]}
      >
        <CarouselContent>
          {facts.map((fact) => (
            <CarouselItem key={fact}>
              <div className="px-10">
                <Card>
                  <CardContent className="flex items-center justify-center p-6 text-sm">
                    {fact}
                  </CardContent>
                </Card>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="absolute left-1 top-1/2 -translate-y-1/2" />
        <CarouselNext className="absolute right-1 top-1/2 -translate-y-1/2" />
      </Carousel>
    </div>
  );
}
